import { uniq } from 'lodash-es';
import type { FC } from 'react';

import { useBulkSelectionContext } from '../BulkSelectionContext';
import Checkbox from '../Checkbox';
import { getBulkItemSelectionStatus } from './helpers';
import type { BulkSelectionStatus } from './types';

interface Props {
  dataIds: string[];
  selectionId: string;
}

const BulkSelectionCheckbox: FC<Props> = ({ dataIds, selectionId }) => {
  const { addItems, getItems, removeItems } = useBulkSelectionContext();
  const selectedItems: string[] = getItems(selectionId);
  const selectionStatus: BulkSelectionStatus = getBulkItemSelectionStatus(dataIds, selectedItems);
  const isIndeterminate: boolean = selectionStatus === 'somePageItemsSelected';

  const handleBulkSelectionChange = (bulkItemKey: string): void => {
    if (selectionStatus === 'allPageItemsSelected') {
      return removeItems(bulkItemKey, dataIds);
    }

    let newSelectedItemsList: string[] = [];

    if (selectionStatus === 'noPageItemsSelected') {
      newSelectedItemsList = uniq(dataIds);
    }

    if (selectionStatus === 'somePageItemsSelected') {
      const itemsMissingInSelectedItems: string[] = dataIds.filter((dataId: string) => !selectedItems.includes(dataId));

      newSelectedItemsList = [...selectedItems, ...itemsMissingInSelectedItems];
    }

    addItems(bulkItemKey, newSelectedItemsList);
  };

  const handleChange = () => {
    handleBulkSelectionChange(selectionId);
  };

  return (
    <Checkbox checked={selectionStatus === 'allPageItemsSelected'} indeterminate={isIndeterminate} onChange={handleChange} />
  );
};

export type { Props as BulkSelectionCheckboxProps };

export default BulkSelectionCheckbox;
